export default __webpack_public_path__ + "static/media/coverHospital.8ce99c94.svg";